export enum MoistureSensorState {
    WET,
    DRY,
};